const NotificationSetting = () => {

	return (
		<>
			<div className="setting-detail-list">
				<div className="title-text">
					<h3>Notifications Settings</h3>
				</div>
				<div className="accordion" id="accordionExample">
					<div className="accordion-item">
						<h2 className="accordion-header"
							id="notificationone">
							<button
								className="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#notione"
								aria-expanded="false"
								aria-controls="notione">
								<img src='images/setting/1.svg' />
								<div className='title'>
									<h4>Ticket Management</h4>
									<p>Neque porro quisquam est qui dolorem ipsum.</p>
								</div>
							</button>
						</h2>
						<div id="notione"
							className="accordion-collapse collapse"
							aria-labelledby="notificationone"
							data-bs-parent="#accordionExample">
							<div className="accordion-body accbody">
								<div className="row">
									<div className="div-acc">
										<p>New Ticket</p>
										<div
											className="basic-form mx-3">
											<label
												className="switch112 "><input
													type="checkbox" /><span><em></em><strong></strong></span></label>
										</div>
									</div>
									<div className="div-acc">
										<p>Edit Ticket</p>
										<div
											className="basic-form mx-3">
											<label
												className="switch112 "><input
													type="checkbox" /><span><em></em><strong></strong></span></label>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="accordion-item">
						<h2 className="accordion-header"
							id="notificationtwo">
							<button
								className="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#notitwo"
								aria-expanded="false"
								aria-controls="notitwo">
								<img src='images/setting/2.svg' />
								<div className='title'>
									<h4>Assessment</h4>
									<p>Neque porro quisquam est.</p>
								</div>
							</button>
						</h2>
						<div id="notitwo"
							className="accordion-collapse collapse"
							aria-labelledby="notificationtwo"
							data-bs-parent="#accordionExample">
							<div className="accordion-body accbody">
								<div className="row">
									<div className="div-acc">
										<p>Self Assessment</p>
										<div
											className="basic-form mx-3">
											<label
												className="switch112 "><input
													type="checkbox" /><span><em></em><strong></strong></span></label>
										</div>
									</div>
									<div className="div-acc">
										<p>Employee Assessment</p>
										<div
											className="basic-form mx-3">
											<label
												className="switch112 "><input
													type="checkbox" /><span><em></em><strong></strong></span></label>
										</div>
									</div>
									<div className="div-acc">
										<p>HR Assessment</p>
										<div
											className="basic-form mx-3">
											<label
												className="switch112 "><input
													type="checkbox" /><span><em></em><strong></strong></span></label>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="accordion-item">
						<h2 className="accordion-header"
							id="notification3">
							<button
								className="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#noti3"
								aria-expanded="false"
								aria-controls="noti3">
								<img src='images/setting/3.svg' />
								<div className='title'>
									<h4>Position</h4>
									<p>Neque porro quisquam est qui dolorem ipsum.</p>
								</div>
							</button>
						</h2>
						<div id="noti3"
							className="accordion-collapse collapse"
							aria-labelledby="notification3"
							data-bs-parent="#accordionExample">
							<div className="accordion-body accbody">
								<div className="row">
									<div className="div-acc">
										<p>New Position</p>
										<div
											className="basic-form mx-3">
											<label
												className="switch112 "><input
													type="checkbox" /><span><em></em><strong></strong></span></label>
										</div>
									</div>
									<div className="div-acc">
										<p>Closed Position</p>
										<div
											className="basic-form mx-3">
											<label
												className="switch112 "><input
													type="checkbox" /><span><em></em><strong></strong></span></label>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="accordion-item">
						<h2 className="accordion-header"
							id="notification4">
							<button
								className="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#noti4"
								aria-expanded="false"
								aria-controls="noti4">
								<img src='images/setting/4.svg' />
								<div className='title'>
									<h4>Learning</h4>
									<p>Neque porro quisquam est qui dolorem ipsum.</p>
								</div>
							</button>
						</h2>
						<div id="noti4"
							className="accordion-collapse collapse"
							aria-labelledby="notification4"
							data-bs-parent="#accordionExample">
							<div className="accordion-body accbody">
								<div className="row">
									<div className="div-acc">
										<p>Self Learning</p>
										<div
											className="basic-form mx-3">
											<label
												className="switch112 "><input
													type="checkbox" /><span><em></em><strong></strong></span></label>
										</div>
									</div>
									<div className="div-acc">
										<p>Online Learning</p>
										<div
											className="basic-form mx-3">
											<label
												className="switch112 "><input
													type="checkbox" /><span><em></em><strong></strong></span></label>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
export default NotificationSetting;